import { LoggerService } from '../../common/common.module'
import { CreateEditController, CreateEditScope } from '../../common/common.create-edit.controller'
import { CreateEditInitParams } from '../../common/create-edit-popup/create-edit-popup.controller'

import { PopupType } from '../../../helpers/popup-manager'
import { IUserSession, EventsNames, LocalizationHelper, CommonHelper, ConvertHelper, ToastHelper, LogHelper } from '../../../helpers'

import { OpTaskType } from '../../../models/core'
import { Enums } from '../../../models/common/enums'
import { IOpObject } from '../../../models/util/interfaces'

import { TaskTypeHelper } from '../tasks-types.helper'

interface TaskTypeCreateEditScope extends CreateEditScope { }

export class TaskTypeCreateEditController extends CreateEditController  {

    // Members

    private taskType: OpTaskType

    // Members End


    // Ctor

    constructor(
        private readonly $scope: TaskTypeCreateEditScope,
        private readonly $q: ng.IQService,
        private readonly $timeout: ng.ITimeoutService,
        private readonly userSession: IUserSession,
        protected readonly referenceType: Enums.ReferenceType,
        private readonly moduleName: Enums.SimaxModuleName
    ) {
        super(referenceType)

        this.setEvents()
        this.setOptions()
    }

    // Ctor End


    // Events

    private onInit(args: any[]): void {
        if (args && args[0]) {
            const createEditInitParams: CreateEditInitParams = args[0]

            this.taskType = createEditInitParams ? createEditInitParams.referenceObject as any : null
            this.$scope.$broadcast(EventsNames.SHOW_CREATE_EDIT_POPUP, PopupType.CREATE_EDIT_POPUP)

            if (this.taskType && this.taskType.getReferenceKey() > 0) {
                this.$scope.options.title = LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__EDITING, this.moduleName)
            } else {
                this.$scope.options.title = LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__ADDING, this.moduleName)
            }

            this.$timeout(() => {
                this.$scope.$broadcast(EventsNames.OPEN_CREATE_EDIT_POPUP, createEditInitParams)
            })
        }
    }

    private onSave(objectToSave: IOpObject): ng.IPromise<IOpObject> {
        const deferred = this.$q.defer<IOpObject>()

        TaskTypeHelper
            .saveTaskType(this.userSession, TaskTypeHelper.createOpTaskTypeFromIOpObject(objectToSave, this.taskType))
            .then((savedObject: OpTaskType) => {
                CommonHelper.setValueToLocalStorage(CommonHelper.localStorageVarForSavedEntity.taskTypeSaved, true, 0)
                this.$scope.$root.$broadcast(EventsNames.CLOSE_CREATE_EDIT_POPUP, savedObject)

                deferred.resolve(savedObject as any)
            })
            .fail((error: any) => {
                deferred.reject(error)
            })

        return deferred.promise
    }

    private onBulkSave(objectToSave: IOpObject): ng.IPromise<IOpObject> {
        const deferred = this.$q.defer<IOpObject>()

        return deferred.promise
    }

    // Events End


    // Setup

    private setEvents(): void {
        this.$scope.$on(
            EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__OPEN_CREATE_EDIT_POPUP, this.moduleName),
            (event: ng.IAngularEvent, ...args: any[]) => this.onInit(args)
        )
    }

    private setOptions(): void {
        this.$scope.popupVisible = false
        this.$scope.options = {
            title: '',
            type: null,
            referenceType: this.referenceType,
            onSave: (objectToSave: IOpObject) => this.onSave(objectToSave),
            onBulkSave: null,
            onSubmit: null,
            onClose: null,
            submitBulkEdit: null,
            localStorageVarForSavedEntity: CommonHelper.localStorageVarForSavedEntity.groupingLocationTypeSaved,
            succsessMessage: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__SAVED, this.moduleName),
        }
    }

    // Setup End
}